import { useEffect, useMemo, useState } from "react";
import {
    Cpu,
    FileText,
    Image,
    Layers,
    Mail,
    Package,
    Zap
} from "react-feather";

const ITEMS = [
    {
        icon: Cpu,
        title: "AI Signage Intelligence",
        text: "Analyzing your storefront, layout and project requirements."
    },
    {
        icon: Layers,
        title: "Material Expertise",
        text: "Selecting realistic sign systems, lighting methods and mounting solutions."
    },
    {
        icon: Image,
        title: "Photorealistic Visualization",
        text: "Creating high-quality renders that closely match the final installation."
    },
    {
        icon: FileText,
        title: "Professional Estimation",
        text: "Calculating dimensions, production costs and installation estimates."
    },
    {
        icon: Package,
        title: "Commercial Documentation",
        text: "Preparing a polished proposal with specifications, pricing and project details."
    },
    {
        icon: Mail,
        title: "Ready for Presentation",
        text: "Delivering a complete proposal ready to share with your client."
    }
];

export default function AiProgressCarousel({ done = false, error = false }) {
    const [index, setIndex] = useState(0);
    const [dots, setDots] = useState(1);

    useEffect(() => {
        if (done || error) return;

        const interval = setInterval(() => {
            setDots((prev) => (prev >= 3 ? 1 : prev + 1));
        }, 650);

        return () => clearInterval(interval);
    }, [done, error]);

    useEffect(() => {
        if (done || error) return;

        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % ITEMS.length);
        }, 4200);

        return () => clearInterval(interval);
    }, [done, error]);

    const current = useMemo(() => {
        if (error) {
            return {
                icon: Zap,
                title: "Process interrupted",
                text: "Something went wrong while generating your project"
            };
        }

        if (done) {
            return {
                icon: Package,
                title: "Project completed",
                text: "Your proposal is ready"
            };
        }

        return ITEMS[index];
    }, [index, done, error]);

    const Icon = current.icon;

    return (
        <div
            key={current.title}
            className={`ai-progress-carousel ai-progress-animate ${done ? "done" : ""} ${error ? "error" : ""}`}
        >
            <div className="ai-progress-icon">
                <Icon size={22} />
            </div>

            <div className="ai-progress-copy">
                <div className="ai-progress-title">
                    {current.title}
                    {!done && !error && <span className="ai-progress-dots">{".".repeat(dots)}</span>}
                </div>

                <div className="ai-progress-text">
                    {current.text}
                </div>
            </div>
        </div>
    );
}